import { apiUrl } from '../config/api'

export async function listShopLocationFees(params = {}) {
  const qs = new URLSearchParams()
  if (params.shopId) qs.set('shopId', String(params.shopId))
  if (params.locationId) qs.set('locationId', String(params.locationId))
  const url = apiUrl(`/api/shop-location-fees${qs.toString() ? `?${qs.toString()}` : ''}`)
  const res = await fetch(url, { headers: { Accept: 'application/json' }, credentials: 'include' })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function createShopLocationFee(payload) {
  const res = await fetch(apiUrl('/api/shop-location-fees'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload), // { shopId, locationId, fee }
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function updateShopLocationFee(shopId, locationId, payload) {
  const res = await fetch(apiUrl(`/api/shop-location-fees/${shopId}/${locationId}`), {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

export async function deleteShopLocationFee(shopId, locationId) {
  const res = await fetch(apiUrl(`/api/shop-location-fees/${shopId}/${locationId}`), { method: 'DELETE', credentials: 'include' })
  if (!res.ok) throw new Error(await res.text())
  return true
}
